<template>
    <a-modal name="reviews-modal">
        <div
            class="reviews-link"
            @click.self="closeModal"
        >
            <svg
                class="reviews-link-background"
                width="1597"
                height="431"
                viewBox="0 0 1597 431"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect x="-3" width="1600" height="431" fill="#6367A7"/>
            </svg>
            <div class="reviews-modal">
        <span
            @click="closeModal"
            class="reviews-modal__close"
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect y="14.1426" width="20" height="2" transform="rotate(-45 0 14.1426)" fill="#68737D"/>
            <rect x="14.1484" y="15.5566" width="20" height="2" transform="rotate(-135 14.1484 15.5566)"
                  fill="#68737D"/>
          </svg>
        </span>

                <h2 class="reviews-modal__title">
                    Написать отзыв
                </h2>
                <AInput
                    type="textarea"
                    label="Отзыв о DOS"
                    v-model="text"
                />
                <ABtn
                    label="Отправить"
                    bg="#00A59E"
                    @click.native="send"
                />
            </div>
        </div>
    </a-modal>
</template>

<script>
import {computed} from 'vue';
import {AModal, useAModal, AInput, ABtn} from '../../ui';

export default {
    name: 'ReviewsModal',
    props: ['result', 'modelValue'],
    components: {
        AModal,
        AInput,
        ABtn,
    },
    setup(props, ctx) {
        const modal = useAModal();

        const text = computed({
            get() {
                return props.modelValue
            },
            set(val) {
                ctx.emit('update:modelValue', val)
            }
        })

        const closeModal = () => {
            text.value = ''
            modal.hide();
        }

        const send = () => {
            ctx.emit('onSubmit', text.value)
        }

        return {
            closeModal,
            text,
            send
        }
    }
}
</script>

<style lang="scss" scoped>
.reviews-link {
    min-height: 100vh;
    background-color: #fff;
}

.reviews-link-background {
    position: absolute;
    display: block;
    width: 100%;
    height: auto;
    pointer-events: none;
}

.reviews-modal {
    position: absolute;
    max-width: 684px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #FFFFFF;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05), 0px 0px 40px rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    padding: 45px 64px 60px 57px;
    width: 100%;
    max-height: 100vh;
    overflow-y: auto;
    @include mobile {
        padding: 20px;
    }

    &__title {
        margin: 0 0 36px;
    }

    &__close {
        position: absolute;
        top: 22px;
        right: 17px;
        cursor: pointer;
    }

    :deep {
        .label {
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: #68737D;
        }

        .field {
            margin: 0 0 35px;
        }

        .a-btn {
            min-width: 270px;
        }
    }
}
</style>